import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Clock, ArrowUpRight } from 'lucide-react';
import { blogPosts, blognumber } from '../mock';

const Blog = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Show only the 3 most recent on the home page
  const posts = blogPosts.slice(blognumber-3, blognumber-0).reverse();

  const handleViewAll = () => {
    if (location.pathname === '/') {
      navigate('/blog');
    } else {
      navigate('/blog');
    }
  };

  return (
    <section id="blog" className="relative py-28 bg-[#0d0d0d]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">BLOG</p>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              From the <span className="text-amber-400 italic">study room</span>
            </h2>
          </div>
          <button
            onClick={handleViewAll}
            className="inline-flex items-center gap-2 text-amber-400 hover:gap-3 transition-all duration-300"
          >
            View all posts <ArrowUpRight size={18} />
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              className="group rounded-2xl overflow-hidden bg-white/[0.02] border border-white/10 hover:border-amber-400/40 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/80 to-transparent" />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-amber-400/90 text-[#0a0a0a] text-xs font-medium tracking-wide">
                  {p.category}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-white/50 text-xs">
                  <span>{p.date}</span>
                  <span>•</span>
                  <span className="flex items-center gap-1">
                    <Clock size={12} /> {p.readTime}
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-white text-2xl leading-[1.25] group-hover:text-amber-400 transition-colors duration-300">
                  {p.title}
                </h3>
                <p className="mt-3 text-white/60 text-[14.5px] leading-relaxed line-clamp-2">
                  {p.excerpt}
                </p>
                <div className="mt-5 inline-flex items-center gap-2 text-amber-400 text-sm group-hover:gap-3 transition-all duration-300">
                  Read article <ArrowUpRight size={15} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
